module.exports = __webpack_public_path__ + "static/media/living.4889c9cd.gif";